module.exports = __webpack_public_path__ + "static/section4-bac993c575b44df8c5823fd055d6be0d.svg";